export function getItemDisplayName(shortname: string): string {
    return shortname
}

// Centralised icon URL builder. Icons are served straight from the rusthelp
// CDN, keyed by shortname. They're exported at 48/64/128/256 (plus a 512
// source); 128px keeps our ~56px slots crisp on high-DPI displays.
export function getItemIconUrl(shortname: string): string {
    return `https://cdn.rusthelp.com/images/public/128/${shortname}.png`
}
